import { RootState } from '../types';

export function isMobileMenuOpen(state: RootState): boolean {
    return state.menu.open;
}
